export interface IMenuItem {
	id: number
	title: string
	path: string
	external?: boolean
	subMenu?: IMenuItem[]
}

export interface IMenuApi {
    getMenuByCustomer: (customerId: string) => Promise<IMenuItem[]>,
}

const MenuApiType = {
    IMenuApi: Symbol("IMenuApi"),
};

export default MenuApiType;
